export default __webpack_public_path__ + "static/media/heavyvehicle.0c2920be.png";